import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              专题索引
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              按分类快速浏览你最感兴趣的吃瓜内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {indexItems.map((item) => (
              <div
                key={item.id}
                className="p-5 rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-300 transition-colors duration-200 cursor-pointer flex flex-col"
              >
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                  <i className={`${item.icon} text-lg text-secondary-600 w-4 h-4 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 flex-1">{item.desc}</p>
                <span className="text-xs text-primary-500 font-medium">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}